
import { Component, Vue } from 'vue-property-decorator'

/**
 * liタグの基底コンポーネント
 */
@Component
export default class ListItemBase extends Vue {}
